<template>
    <div id="ContainerPatientePharmacy">
        <ePharmacyBase v-bind:Origin="'Patient'" />
    </div>
</template>

<script>

import DBFunctions from '@/common/DBFunctions.js'
import EnumService from '@/services/enum.service' 
import Permission from '@/common/Permission'

//import { EventBus } from '@/event-bus.js';
export default {
    name: 'ePharmaryPatient',
   mixins: [DBFunctions, Permission],
   data(){
    return {
        //permission:[],
        //Menu : this.$store.state.leftMenu,
        OptionsRightMenu:{
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false              
      },
    }
   },

   mounted(){
    this.OptionsRightMenu.visible = true;
    this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems
    this.$emit('getVisibleMenu', this.OptionsRightMenu);
    this.$emit('getBtnRightMenu', this.OptionsRightMenu);
   },
};
</script>